import Vue from 'vue'
import NuxtLoading from './components/nuxt-loading.vue'

import '../../node_modules/swiper/dist/css/swiper.css'

import '../../node_modules/@fortawesome/fontawesome-svg-core/styles.css'

import '../../assets/style/vuetify.styl'

import '../../assets/scss/v_themes/empty_vuetify.scss'

const _d05c333c = () => import('../../layouts/appystudiotopbar.vue'  /* webpackChunkName: "layouts/appystudiotopbar" */).then(m => m.default || m)
const _77430317 = () => import('../../layouts/empty.vue'  /* webpackChunkName: "layouts/empty" */).then(m => m.default || m)
const _e0aae4d2 = () => import('../../layouts/emptyvuetify.vue'  /* webpackChunkName: "layouts/emptyvuetify" */).then(m => m.default || m)
const _6f6c098b = () => import('./layouts/default.vue'  /* webpackChunkName: "layouts/default" */).then(m => m.default || m)

const layouts = { "_appystudiotopbar": _d05c333c,"_empty": _77430317,"_emptyvuetify": _e0aae4d2,"_default": _6f6c098b }

let resolvedLayouts = {}

export default {
  head: {"title":"Appy Email Editor","meta":[{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"},{"hid":"description","name":"description","content":"A stylish, multi-tasking wedding website and app for you and your guests. Share events, manage RSVPs, collect photos and more!"}],"link":[{"hid":"favicon","rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Material+Icons"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Raleway:300,400,500,600"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Open+Sans"},{"rel":"stylesheet","href":"https:\u002F\u002Fpro.fontawesome.com\u002Freleases\u002Fv5.5.0\u002Fcss\u002Fsolid.css","integrity":"sha384-YIyAArzQv8q6Av1kr9cwxHhFcfNBUaolJindR2XO8E3OLp6z3d8My3oWLd33ET7M","crossorigin":"anonymous"},{"rel":"stylesheet","href":"https:\u002F\u002Fpro.fontawesome.com\u002Freleases\u002Fv5.5.0\u002Fcss\u002Flight.css","integrity":"sha384-33RmjeesW9BZ4wR2Gm3n4iBXOvGTto4znqL2kZleiRanWDxM59IHIq5RsbRioqxb","crossorigin":"anonymous"},{"rel":"stylesheet","href":"https:\u002F\u002Fpro.fontawesome.com\u002Freleases\u002Fv5.5.0\u002Fcss\u002Ffontawesome.css","integrity":"sha384-srL3Qh9R\u002Fn855m4o5fegS\u002F\u002FB2q0R1md7z6ndDYaPj8iEp0j0IuKdFVWMY0JosKPF","crossorigin":"anonymous"}],"script":[{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fbabel-polyfill\u002F6.26.0\u002Fpolyfill.js"},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fevent-source-polyfill\u002F0.0.9\u002Feventsource.js"}],"style":[]},

  render(h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [ templateEl ])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,
      transitionEl
    ])
  },
  data: () => ({
    isOnline: true,
    layout: null,
    layoutName: ''
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this
      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
  },

  mounted() {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline() {
      return !this.isOnline
    }
  },
  methods: {
    refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },

    setLayout(layout) {
      if (!layout || !resolvedLayouts['_' + layout]) layout = 'default'
      this.layoutName = layout
      let _layout = '_' + layout
      this.layout = resolvedLayouts[_layout]
      return this.layout
    },
    loadLayout(layout) {
      const undef = !layout
      const nonexistent = !(layouts['_' + layout] || resolvedLayouts['_' + layout])
      let _layout = '_' + ((undef || nonexistent) ? 'default' : layout)
      if (resolvedLayouts[_layout]) {
        return Promise.resolve(resolvedLayouts[_layout])
      }
      return layouts[_layout]()
        .then((Component) => {
          resolvedLayouts[_layout] = Component
          delete layouts[_layout]
          return resolvedLayouts[_layout]
        })
        .catch((e) => {
          if (this.$nuxt) {
            return this.$nuxt.error({ statusCode: 500, message: e.message })
          }
        })
    }
  },
  components: {
    NuxtLoading
  }
}
